module.exports = __webpack_public_path__ + "static/media/4ODA1.b1a231f1.jpg";